import i18next from 'i18next'
import moment, {Moment} from 'moment'
import {Interval} from '@/stores/reports/models/Interval'
import {DATE_FORMAT, TITLE_DAY_MONTH_FORMAT} from '@/constants'

export const generateInterval = ({from, to}: {from: Moment; to: Moment}): Interval => {
    const difference = moment.duration(to.diff(from)).asDays()
    if (difference <= 1) {
        return Interval.HOUR
    } else if (difference < 32) {
        return Interval.DAY
    } else if (difference < 61) {
        return Interval.WEEK
    } else if (difference < 366) {
        return Interval.MONTH
    } else {
        return Interval.YEAR
    }
}

export const generateChartTitleForRange = ({from, to}: {from: Moment; to: Moment}) => {
    //check the years
    if (from.get('year') === to.get('year')) {
        return `${from.format(TITLE_DAY_MONTH_FORMAT)} - ${to.format(DATE_FORMAT)}`
    }

    //if the years are different
    return `${from.format(DATE_FORMAT)} - ${to.format(DATE_FORMAT)}`
}

export const getIntervalValue = ({interval, date, dayFormat}: {interval: Interval; date: Moment; dayFormat?: string}) => {
    switch (interval) {
        case Interval.HOUR: {
            return date.format('HH:mm')
        }
        case Interval.DAY: {
            return `${date.format(dayFormat || 'DD.MM')}`
        }
        case Interval.WEEK: {
            return `${i18next.t('TransactionsCardWithBarChartContainerStore.week')} ${date.week()}`
        }
        case Interval.MONTH: {
            return date.format('MMM')
        }
        case Interval.YEAR: {
            return date.format('YYYY')
        }
    }
}

